export const SOURCE_DATA_GRID = 'sourceDataGrid';
export const DATA_GRID_SEARCH_PARAMS_ID = 'dataGrids';
export const DEFAULT_ROW_INDEX = 1;

export type DataGridSearchParams = {
  gridCode: string;
  queryId: string;
  rowIndex: string;
};
